import React from 'react';
import {connect} from 'react-redux';

import LANGUAGES_CONTROLLER from '../../../controllers/languages';

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('FORMATTED_PERCENTAGE', LOG_LEVELS.ERROR);

// TODO: Add support for showing currency symbol, brackets for -ve numbers, decimal & thousands separator, etc

export class FormattedPercentage extends React.Component {
  changeHandler(event) {
    log.debug('changeHandler(): ', event);
    log.debug('changeHandler(): target.value', event.target.value);
    let changedValue;
    if (this.props.editOptions) {
      if (!this.props.editOptions.fieldName) {
        changedValue = event.target.value !== '' ? event.target.value : undefined;
      }
      else {
        changedValue = {};
        changedValue[this.props.editOptions.fieldName] = event.target.value !== '' ? event.target.value : undefined;
      }
      this.props.editOptions.changeHandler(changedValue);
    }
  }

  render() {
    log.debug('render(): ', this.props);
    const value = parseFloat(this.props.value);
    const invalidNumber = isNaN(value);
    log.debug('render(): ', value, invalidNumber);

    const formattedNumber = invalidNumber ?
      LANGUAGES_CONTROLLER.format(this.props.languages, 'conversionError_invalidPercentageValue') :
      value.toFixed(this.props.decimalPlaces);


    if (this.props.editOptions) {
      return (
        <span
          className={'formatted-currency '+this.props.className}>
          <input
            type='number'
            value={formattedNumber}
            placeholder={this.props.editOptions.prompt || ''}
          /> %
        </span>
      )
    }
    return (
      <span
        className={'formatted-currency '+this.props.className}>
        {formattedNumber} %
        </span>
    );

  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


FormattedPercentage.defaultProps = {
  decimalPlaces: 0,
  className: ''
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(FormattedPercentage);